<template>
    <div class="flex items-center">
          <div v-show="isHidden" class="w-full">
              <span v-html="rendercontent"></span><a @click="show" class="text-xxs align-middle whitespace-no-wrap inline-block cursor-pointer"><i :class="['material-icons align-middle mx-1', buttonsize]">{{buttonicon}}</i>{{buttonname}}</a>
          </div>
          <div v-if="!isHidden" class="flex w-full items-center" v-click-outside="onClickOutside">
            <div class="flex pr-1 w-10/12">
              <textarea class="w-full" id="groupName" type="text"
                     @keydown.enter="putItem"
                     v-model="rendercontent"
                     autofocus
                     rows="3"
                     v-html="rendercontent"
              >
            </textarea>
            </div>
            <div class="w-2/12">
              <button 
                @click="putItem" 
                type="submit" 
                class="commitbutton p-0 inline-block w-10"
                :class="{ 'loading': submitting }"
              ><i aria-hidden="true" class="material-icons align-middle text-3xl">check</i></button>
            </div>
            <div v-if="errors.length">
              <p v-for="error in errors"
                class="leading-tight text-red-700 text-xs pb-0 my-3"
              >
                {{ error }}
              </p>
            </div>
          </div>
      </div>
</template>

<script>
import vClickOutside from 'v-click-outside'
import axios from 'axios'

  export default {

        props: {
            content: '',
            route:'',
            routeparam:'',
            buttonname: {
              default: 'Change',
            },
            buttonicon: {
              default: 'edit',
            },
            buttonsize: {
              default: 'text-xs',
            },
        },

        data() {
          return {
            isHidden: true,
            submitting: false,
            errors: [],
            rendercontent: this.content,
          }
        },
        directives: {
          clickOutside: vClickOutside.directive
        },
        methods: {
          onClickOutside (event) {
              this.isHidden = !this.isHidden
          },
          show() {
            this.isHidden = ! this.isHidden;
            this.focusOnField();
          },
          focusOnField() {
            this.$nextTick(() => {
              this.$refs.input?.focus();
            });
          },
          mounted(){
            this.formfocus()
          },

          putItem: function (event) {
            if (! this.submitting) {
              this.submitting = true;
              this.errors = [];
              axios.put(this.route,
                { [this.routeparam]: this.rendercontent }
              )
              .then(() => {
                location.reload();
              })
              .catch((errors) => {
                this.submitting = false;
                this.errors = errors.response?.data?.errors?.[this.routeparam] || [];
              })
            };
          }

        },
      }
</script>
